import {
  Box,
  Container,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
} from '@chakra-ui/react';

const FaqItem = ({ question, answer }) => {
  return (
    <AccordionItem border="none" mb={4}>
      <h2>
        <AccordionButton
          bg="white" // Em vez de useColorModeValue('white', 'gray.800')
          borderRadius="md"
          p={4}
          _hover={{ bg: "gray.50" }} // Em vez de useColorModeValue('gray.50', 'gray.700')
          boxShadow="md"
        >
          <Box flex="1" textAlign="left" fontWeight="600" color="brand.primary">
            {question}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel
        pb={4}
        pt={2}
        px={4}
        color="gray.600" // Em vez de useColorModeValue('gray.600', 'gray.400')
      >
        {answer}
      </AccordionPanel>
    </AccordionItem>
  );
};

const Faq = () => {
  return (
    <Box bg="gray.50" py={20} id="faq">
      <Container maxW={'800px'}>
        <Heading
          as="h2"
          fontSize={{ base: '3xl', md: '4xl' }}
          textAlign={'center'}
          mb={16}
          color="brand.primary"
        >
          Perguntas Frequentes
        </Heading>

        <Accordion allowMultiple allowToggle>
          <FaqItem
            question="Como funcionam os créditos?"
            answer="Cada crédito permite transformar uma foto em um desenho para colorir. Após a compra, os créditos ficam disponíveis na sua conta e você pode utilizá-los quando quiser. Um crédito = uma transformação."
          />
          <FaqItem
            question="Quanto tempo leva para gerar meu desenho?"
            answer="O processo de transformação é quase instantâneo! Em poucos segundos após o upload da sua foto, você receberá seu desenho pronto para download e impressão."
          />
          <FaqItem
            question="Em que formato recebo meus desenhos?"
            answer="Seus desenhos são entregues em formato JPG de alta resolução, pronto para impressão."
          />
          <FaqItem
            question="Posso imprimir em qualquer impressora?"
            answer="Sim! Os desenhos são otimizados para impressão em qualquer impressora doméstica comum. Recomendamos papel mais grosso (120g ou superior) para melhores resultados ao colorir."
          />
          <FaqItem
            question="Os créditos expiram?"
            answer="Não se preocupe! Seus créditos não expiram e ficam disponíveis na sua conta por tempo indeterminado, então você pode usá-los quando for mais conveniente."
          />
        </Accordion>
      </Container>
    </Box>
  );
};

export default Faq;